"use client";

import React from "react";
import { ShieldCheck, Mail, Building, Lock } from "lucide-react";
import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
import { Link } from "@/components/common/Link";
export default function ContactFormsAndBusinessInquiries() {
  const {
    ref: contentRef,
    isVisible: isContentVisible
  } = useRevealOnScroll({
    threshold: 0.1
  });
  const securityPoints = [{
    id: 1,
    text: "Secure handling of submitted data using industry-standard security protocols."
  }, {
    id: 2,
    text: "Strict internal access controls following industry-standard security protocols."
  }, {
    id: 3,
    text: "Compliant with industry-standard security protocols for corporate privacy."
  }];
  return <section id="contact-forms-and-business-inquiries" className="bg-[#0F172A] min-h-screen py-3 md:py-4 lg:py-5 scroll-mt-[120px]">
            <div className="max-w-7xl mx-auto px-6">
                
                <Card ref={contentRef} className={`max-w-4xl mx-auto bg-[#142033] border-[rgba(19,184,200,0.18)] shadow-2xl transition-all duration-700 ease-out py-0 ${isContentVisible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-8'}`}>
                    <CardHeader className="p-8 md:p-12 lg:p-16 pb-0">
                        <div className="space-y-6">
                            <div className="inline-flex items-center gap-2 px-3 py-1 rounded-md bg-[#13B8C8]/10 text-[#13B8C8] text-sm font-medium w-fit">
                                <Building className="size-4" />
                                <span>Corporate Relations</span>
                            </div>
                            <CardTitle>
                                <h2 className="text-3xl md:text-4xl lg:text-5xl font-default font-bold tracking-tight leading-tight text-[#F8FAFC]">
                                    Business Inquiries & Consultation
                                </h2>
                            </CardTitle>
                            <p className="text-[#CBD5E1] text-lg leading-relaxed max-w-2xl">
                                FETC maintains rigorous standards for the intake and management of business inquiries. We ensure that all corporate communications are handled with the highest level of professional discretion and technical security.
                            </p>
                        </div>
                    </CardHeader>

                    <CardContent className="p-8 md:p-12 lg:p-16 pt-0 space-y-12">
                        <div className="space-y-6">
                            <h3 className="text-xl font-default font-semibold flex items-center gap-2 text-[#F8FAFC]">
                                <Lock className="size-5 text-[#13B8C8]" />
                                Data Processing & Security
                            </h3>
                            <p className="text-sm text-[#CBD5E1] leading-relaxed">
                                All information shared with FETC is protected by enterprise-grade encryption protocols. Your inquiry is routed directly to our specialized department heads to ensure confidentiality and expert review. We adhere to strict internal governance to prevent unauthorized access to your corporate data.
                            </p>
                            <ul className="space-y-3 text-sm text-[#CBD5E1]">
                                {securityPoints.map((point, i) => <li key={point.id} data-index={i} className="flex items-start gap-3">
                                        <ShieldCheck className="size-5 text-[#13B8C8] shrink-0" />
                                        <span>{point.text}</span>
                                    </li>)}
                            </ul>
                        </div>

                        <div className="pt-8 border-t border-[rgba(19,184,200,0.18)]">
                            <div className="grid grid-cols-1 gap-8">
                                <div className="flex items-center gap-4 text-[#CBD5E1] hover:text-[#F8FAFC] transition-colors group">
                                    <div className="size-10 rounded-lg bg-[#0B1220] flex items-center justify-center shrink-0 border border-[rgba(19,184,200,0.18)] group-hover:border-[#13B8C8]/50 transition-colors">
                                        <Mail className="size-5 text-[#13B8C8]" />
                                    </div>
                                    <div>
                                        <p className="text-sm font-medium text-[#13B8C8]">Direct Email</p>
                                        <p className="text-sm text-[#F8FAFC] font-medium">ehab.hashiem@fetc.ae</p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </CardContent>
                </Card>
                
                <div className="mt-12 text-center">
                    <p className="text-sm text-[#CBD5E1]">
                        For further information regarding our data handling practices, please review our <Link to="/PrivacyPolicyPage" className="text-[#13B8C8] hover:underline">Privacy Policy</Link>.
                    </p>
                </div>

            </div>
        </section>;
}